/* eslint-disable max-lines */
// @ts-nocheck
/* eslint-disable no-mixed-operators */
/* eslint-disable react/prop-types */
import {
  Button,
  ButtonGroup,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Paper,
  Select,
  Typography
} from "@material-ui/core";
import { CANCELLED } from "constants/common/payments";
import { SalesContext } from "contexts/sales";
import CurrencyField from "global/fields/CurrencyField";
import { convertCurrency } from "helpers";
import { getFamilyPlanOptions } from "helpers/process.helper";
import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import { updateSaleScopeById } from "store/actions/sales";
import uniqid from "uniqid";
import PaymentRow from "./PaymentRow";

const useStyles = makeStyles(() => ({
  minwidthInput: {
    minWidth: 250
  }
}));

function Payment(props) {
  const classes = useStyles(props);
  const { scope } = props;

  const salesContext = useContext(SalesContext);

  const [familyPlan, setFamilyPlan] = useState(scope.family_plan);
  const [usePromotionalPrices, setUsePromotionalPrices] = useState(
    scope.use_plan_promotional_prices || false
  );
  const [discount, setDiscount] = useState(scope.discount || "");
  const [discountDollars, setDiscountDollars] = useState("");
  const [discountOption, setDiscountOption] = useState("%");

  const payments = scope.payments.filter(
    payment => payment.status !== CANCELLED
  );
  const filterProcessesNoCourtesy = scope.processes.filter(
    process => !process.is_courtesy
  );

  const hasPlanHistoryToday = () => {
    if (!scope.plan_histories || scope.plan_histories.length === 0) return false;

    const today = new Date().toISOString().slice(0, 10);

    return scope.plan_histories.some(history => {
      const updatedAt = (history.updated_at || "").slice(0, 10);
      return updatedAt === today;
    });
  };

  let amountLeft = parseInt(scope.total, 10);
  payments.forEach(pay => {
    amountLeft -= parseInt(pay.value, 10);
  });

  const totalDiscountDollars = 99;

  const total = Number(scope.total || 0);

  const getTargetItereset = () =>
    scope.isCustomerPayInterest
      ? " (Adicionado para o cliente)"
      : " (Retirado do vendedor)";

  const handleRequestDiscount = newDiscount =>
    props.updateSaleScopeById(scope.id, scope.client_id, {
      discount: newDiscount
    });

  const calculateDiscount = (valueInDollars, newDiscount) => {
    const percentage = newDiscount || discount;
    const dollars = valueInDollars || discountDollars;

    setDiscountDollars(dollars);
    setDiscount(percentage);
    handleRequestDiscount(percentage);
  };

  const handleFocus = w => {
    if (!w && !parseFloat(discount)) {
      setDiscount("");
    }
  };

  const handeDiscountPercentage = () => {
    calculateDiscount(discountDollars, discount);
  };

  const handleChangeDiscount = value => {
    const newValue =
      value < totalDiscountDollars ? value : totalDiscountDollars;
    setDiscount(newValue);
  };

  const handleChangeDollars = value => {
    setDiscountDollars(value);
  };

  const handleCents = value => {
    if (!value) return;

    let newValue = `${value}`;

    if (!newValue.includes(",")) {
      newValue += ",00";
    }

    const sanitizedValue = newValue.replace(/\./g, "").replace(",", ".");
    const numericValue = parseFloat(sanitizedValue);

    const rawHonorary = Number(scope.total_honorary || 0);

    const finalValue = Math.min(numericValue, rawHonorary);

    const newDiscount = ((finalValue * 100) / rawHonorary) * 100;

    const formattedValue =
      finalValue !== numericValue
        ? convertCurrency(finalValue, false)
        : newValue;

    calculateDiscount(formattedValue, newDiscount);
  };

  const handleDiscountOption = option => {
    setDiscountOption(option);
    setDiscount("");
    setDiscountDollars("");
    handleRequestDiscount("");
  };

  const handleTogglePromotionalPrices = event => {
    const checked = event.target.checked;
    setUsePromotionalPrices(checked);

    props.updateSaleScopeById(scope.id, scope.client_id, {
      use_plan_promotional_prices: checked
    });
  };

  const handleSelectFamilyPlan = e => {
    const selected = e.target.value;
    setFamilyPlan(selected);
    salesContext.setSaleKey("family_plan", selected);

    props.updateSaleScopeById(scope.id, scope.client_id, {
      family_plan: selected
    });
  };

  useEffect(() => {
    salesContext.setPaymentConfirmed(amountLeft === 0);
    // eslint-disable-next-line
  }, [amountLeft]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" paragraph>
          Pagamento
        </Typography>
        <Paper elevation={3} style={{ display: "inline-block" }}>
          <Grid container spacing={4}>
            <Grid item>
              <Typography variant="h6" paragraph>
                Valor da venda
              </Typography>
              <Typography variant="subtitle2">
                {"Taxas/Custos: "}
                {convertCurrency(scope.totalTax)}
              </Typography>
              <Typography variant="subtitle2">
                {"Honorários: "}
                {convertCurrency(scope.total_honorary)}
              </Typography>
              {/* {scope.total_minor > 0 && (
                <Typography variant="subtitle2">
                  {"Total menores: "}
                  {convertCurrency(scope.total_minor)}
                </Typography>
              )} */}
              {Boolean(scope.interest_total) && (
                <Typography variant="subtitle2">
                  {"Total de juros: "}
                  {convertCurrency(scope.interest_total)}
                  {getTargetItereset()}
                </Typography>
              )}
              {scope.discount > 0 && (
                <Typography variant="subtitle2">
                  {"Desconto "}
                  <strong>{scope.discount}</strong>%
                </Typography>
              )}
              {scope.cash_back_discount_amount !== null &&
                scope.cash_back_discount_amount > 0 && (
                  <Typography variant="subtitle2">
                    {"Desconto taxas plano familia: "}
                    {convertCurrency(scope.cash_back_discount_amount)}
                  </Typography>
                )}
              <Typography variant="subtitle1">
                <strong>
                  {"Total "}
                  {convertCurrency(total)}
                </strong>
              </Typography>
              {scope.cash_back_value !== null && scope.cash_back_value !== 0 && (
                <Typography variant="subtitle2">
                  {"Total de cashback: "}
                  {convertCurrency(scope.cash_back_value)}
                </Typography>
              )}
            </Grid>
            <Grid item>
              <Grid container spacing={2} style={{ flexDirection: "column" }}>
                <Grid item>
                  <Typography variant="h6">Aplicar desconto</Typography>
                </Grid>
                <Grid item>
                  <ButtonGroup size="small" aria-label="Opções de desconto">
                    <Button
                      variant={
                        discountOption === "%" ? "contained" : "outlined"
                      }
                      disabled={discountOption === "%"}
                      onClick={() => handleDiscountOption("%")}
                    >
                      Porcentagem
                    </Button>
                    <Button
                      variant={
                        discountOption === "$" ? "contained" : "outlined"
                      }
                      disabled={discountOption === "$"}
                      onClick={() => handleDiscountOption("$")}
                    >
                      Valor
                    </Button>
                  </ButtonGroup>
                </Grid>

                {discountOption === "%" ? (
                  <Grid item>
                    <FormControl variant="outlined">
                      <InputLabel htmlFor="discount">Porcentagem</InputLabel>
                      <OutlinedInput
                        id="discount"
                        name="discount"
                        value={discount}
                        onChange={e => handleChangeDiscount(e.target.value)}
                        onBlur={() => handeDiscountPercentage()}
                        onFocus={() => handleFocus(false)}
                        onKeyDown={e => {
                          if (e.keyCode === 13) handeDiscountPercentage();
                        }}
                        aria-describedby="discount"
                        className={classes.minwidthInput}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                      />
                    </FormControl>
                  </Grid>
                ) : (
                  <Grid item>
                    <CurrencyField
                      value={discountDollars}
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">R$</InputAdornment>
                        )
                      }}
                      label="Valor"
                      className={classes.minwidthInput}
                      onFocus={() => handleFocus(true)}
                      onBlur={e => handleCents(e.target.value)}
                      onKeyDown={e => {
                        if (e.keyCode === 13) handleCents(e.target.value);
                      }}
                      onChange={e => handleChangeDollars(e.target.value)}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid item style={{ marginTop: 20 }}>
                <FormControl variant="outlined" required fullWidth>
                  <InputLabel>Plano Familia</InputLabel>

                  <Select
                    value={familyPlan}
                    onChange={handleSelectFamilyPlan}
                    classes={{ selectMenu: classes.select }}
                  >
                    {getFamilyPlanOptions(scope, filterProcessesNoCourtesy)}
                  </Select>
                </FormControl>
              </Grid>
              {(scope.use_plan_promotional_prices || hasPlanHistoryToday()) && (
                <Grid item style={{ marginTop: 8 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={usePromotionalPrices}
                        color="primary"
                        onChange={handleTogglePromotionalPrices}
                      />
                    }
                    label="Usar preços promocionais"
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Paper>
        <Grid container spacing={2}>
          {scope.plan_histories.length > 0 && (
            <Grid item xs={12} style={{ marginTop: 16 }}>
              <Typography variant="h5" paragraph>
                Histórico de planos família
              </Typography>
              <Paper elevation={3} style={{ display: "inline-block" }}>
                <Grid container spacing={4}>
                  {scope.plan_histories.map(history => (
                    <Grid key={uniqid()} item xs={12}>
                      <Typography variant="subtitle2">
                        {`${new Date(history.updated_at).toLocaleDateString()} - Plano anterado de  ${history.old_plan} para ${history.new_plan} por ${history.user.name}`}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            </Grid>
          )}
        </Grid>
        <Grid container spacing={2}>
          {payments.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="h5">Pagamentos registrados</Typography>
            </Grid>
          )}
          {payments
            .filter(a => a.month_number === 1)
            .map(row => (
              <Grid key={uniqid()} item xs={12}>
                <PaymentRow row={row} scope={scope} mode="EDIT" />
              </Grid>
            ))}
          {amountLeft > 0 && (
            <Grid item xs={12}>
              <Typography variant="h5" paragraph>
                Adicionar pagamento
              </Typography>
              <PaymentRow scope={scope} amountLeft={amountLeft} mode="ADD" />
            </Grid>
          )}
          {amountLeft <= 0 && (
            <Grid item xs={12} style={{ marginTop: -8, marginBottom: 16 }}>
              {amountLeft === 0 ? (
                <Typography variant="h5" color="primary">
                  Pagamentos registrados!
                </Typography>
              ) : (
                <Typography variant="h5" color="error">
                  {"Os pagamentos registrados excedem o total da venda em "}
                  <strong>{convertCurrency(amountLeft * -1)}</strong>!
                </Typography>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

const mapStateToProps = state => ({
  scope: state.sales.scope,
  status: state.payment.status
});

export default connect(mapStateToProps, { updateSaleScopeById })(Payment);
